export const VIRUS_API = `/virus-counts`;

export const DISTRICT_API = `/districts`;
